<template>
  <div class="home">
    <div class="mb12 clearfix">
      <div class="fl hmEventL h511 ac bgff">
        <div class="nav clearfix">
          <span class="navLi fl cp" :class="{ curr: curNav === 1 }" @click="choseType(1)">看事件</span>
          <span class="navLi fl cp" :class="{ curr: curNav === 0 }" @click="choseType(0)">读数据</span>
        </div>
        <ul class="typeLi" v-if="curNav === 0">
          <li class="cp fl" v-for="(item, index) in typeLi" :key="index">
            <router-link :to="{ path: 'newsn', query: { type: item.name,api_secret:$route.query.api_secret } }">
              <i :class="'icons icon-' + item.icon"></i>
              <span>{{ item.name }}</span>
            </router-link>
          </li>
        </ul>
        <ul class="typeLi" v-if="curNav === 1">
          <li class="cp fl" v-for="(item, index) in typeLi" :key="index">
            <router-link :to="{ path: 'eventsn', query: { type: item.name,api_secret:$route.query.api_secret } }">
              <i :class="'icons icon-' + item.icon"></i>
              <span>{{ item.name }}</span>
            </router-link>
          </li>
        </ul>
      </div>

      <div class="hmEventR bgff fr">
        <div class="grid clearfix">
          <div class="w541 fl">
            <div class="grid-header clearfix">
              <h2 class="title fl">七日热点事件</h2>
              <div class="fr homeCity">
                <city @cityCallback="citySelect1" ref="citySelect" :isAutoWidth="true" :fullNameofUrl="curFullName">
                </city>
              </div>
            </div>
            <div class="grid-body mt15">
              <div class="echart-warp por h430">
                <mapChart id="mapEchart" :dataArray="mapChartData" :areaName="curMapName" v-if="mapChartData != ''"
                  :isShowTit="showTit"></mapChart>
                <!-- <div class="homeGrid" v-if="mapChartData != ''">
                                    <span>热度值</span> 
                                    <div class="grid-info"><i class="icons icon-ask"></i> <p class="grid-tip r">根据转载传播计算的热度值</p></div>
                                </div> -->
              </div>
            </div>
          </div>
          <div class="w362 fr">
            <div class="grid-header clearfix">
              <router-link class="cr27 fs13 fr" :to="{
                    path: '/eventsN',
                    query: { api_secret:apiSecret},
                  }">查看更多</router-link>
            </div>
            <ul class="news mt10">
              <li v-for="(item, index) in hotAllRank" :key="index">
                <router-link class="cr3d" :to="{
                    path: 'newsDetails',
                    query: { id: item.id, newsType: newsType, type: 7 ,api_secret:apiSecret},
                  }" target="_blank">
                  <span class="title ovhidden fl" :title="item.news_title"><i
                      class="order">{{ index + 1 }}</i>{{ item.news_title }}</span>
                  <strong class="data-num fr">{{ item.exponent }}</strong>
                </router-link>
              </li>
            </ul>
            <div class="no-data pt40" v-if="nodata.hotAllRank">
              <img src="static/images/no_data.png" class="img" /><span class="text">没有数据哦...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix">
      <div class="md5 h585 bgff fl">
        <div class="grid clearfix">
          <div class="grid-header clearfix">
            <h2 class="title">全国数据</h2>
          </div>
          <div class="grid-body mt15">
            <div class="imgText clearfix">
              <router-link class="img fl" :to="{
                  path: 'newsDetails',
                  query: { id: newFir.id, newsType: newsType ,api_secret:apiSecret},
                }" target="_blank"><img :src="newFir.isLoadStart ? newFir.curImg : imgChose(newFir)"
                  :onerror="defaultImg" /></router-link>
              <div class="hidden">
                <h2 class="ovhidden2 mt20">
                  <router-link class="cr00 fs16" :to="{
                      path: 'newsDetails',
                      query: { id: newFir.id, newsType: newsType,api_secret:apiSecret },
                    }" target="_blank">
                    <span class="tag-new cre6" v-if="newFir.is_new === 1">新</span>{{ newFir.news_title }}</router-link>
                </h2>
                <p class="time mt15 cr82">
                  <i class="icons icon-time"></i>{{ timeFilter(newFir.publish_time) }}
                </p>
              </div>
            </div>
            <ul class="index-news mt20">
              <li class="" v-for="(item, index) in newList" :key="index">
                <span class="bull fl">•</span>
                <router-link class="cr3d fl ovhidden" :to="{
                    path: 'newsDetails',
                    query: { id: item.id, newsType: newsType ,api_secret:apiSecret},
                  }" target="_blank">{{ item.news_title }}</router-link>
                <span class="ml5 cre6" v-if="item.is_new === 1">新！</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="md5 fl">
        <div class="h585 ml10 bgff">
          <div class="grid clearfix">
            <div class="grid-header clearfix">
              <h2 class="title fl">{{ curCityName }}数据</h2>
              <div class="fr">
                <city @cityCallback="citySelect" :isHasWorld="isHasWorld" :floatRight="true"></city>
              </div>
            </div>
            <div class="grid-body mt15">
              <div class="imgText clearfix" v-if="cityNewFir != ''">
                <router-link class="img fl" :to="{
                    path: 'newsDetails',
                    query: { id: cityNewFir.id, newsType: newsType ,api_secret:apiSecret},
                  }" target="_blank"><img :src="
                      cityNewFir.isLoadStart
                        ? cityNewFir.curImg
                        : imgChose(cityNewFir)
                    " :onerror="defaultImg" /></router-link>
                <div class="hidden">
                  <h2 class="ovhidden2 mt20">
                    <router-link class="cr00 fs16" :to="{
                        path: 'newsDetails',
                        query: { id: cityNewFir.id, newsType: newsType ,api_secret:apiSecret},
                      }" target="_blank"><span class="tag-new cre6"
                        v-if="cityNewFir.is_new === 1">新</span>{{ cityNewFir.news_title }}</router-link>
                  </h2>

                  <p class="time mt15 cr82">
                    <i class="icons icon-time"></i>{{ timeFilter(cityNewFir.publish_time) }}
                  </p>
                </div>
              </div>
              <ul class="index-news mt20">
                <li class="" v-for="(item, index) in cityNewList" :key="index">
                  <span class="bull fl">•</span>
                  <router-link class="cr3d fl ovhidden" :to="{
                      path: 'newsDetails',
                      query: { id: item.id, newsType: newsType ,api_secret:apiSecret},
                    }" target="_blank">{{ item.news_title }}</router-link>
                  <span class="ml5 cre6" v-if="item.is_new === 1">新！</span>
                </li>
              </ul>
              <div class="no-data pt40" v-if="nodata.cityNewFir">
                <img src="static/images/no_data.png" class="img" /><span class="text">没有数据哦...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="w320 h585 bgff fr">
                <div class="grid clearfix">
                    <ul class="news-img clearfix">
                        <li v-for="(item,index) in viewpointList" :key="index">
                            <router-link class="img" :to="{path:'eventTag',query:{id:item.id,type:item.name}}" target="_blank">
                                <img :src="item.icon" onerror="this.src='static/images/default.png'">
                                <span class="name ovhidden ac">{{item.name}}</span>
                            </router-link>
                        </li>
                        
                    </ul>
                </div>
            </div> -->
    </div>
  </div>
</template>
<script>
  import mapChart from "../components/echart/mapChart.vue";
  import city from "../components/city.vue";
  import AMap from "AMap";
  export default {
    components: {
      mapChart,
      city,
    },
    data() {
      return {
        apiSecret: this.$route.query.api_secret,
        defaultImg: 'this.src="static/images/default.png"',
        curNav: 1,
        showTit: true,
        typeArr: [{
            icon: "tpall",
            name: "全部"
          },
          {
            icon: "sh",
            name: "社会"
          },
          {
            icon: "sz",
            name: "时政"
          },
          {
            icon: "js",
            name: "军事"
          },
          {
            icon: "fz",
            name: "法治"
          },
          {
            icon: "kj",
            name: "科技"
          },
          {
            icon: "cj",
            name: "财经"
          },
          {
            icon: "wh",
            name: "文化"
          },
          {
            icon: "jy",
            name: "教育"
          },
          {
            icon: "jk",
            name: "健康"
          },
          {
            icon: "ly",
            name: "旅游"
          },
          {
            icon: "gy",
            name: "公益"
          },
          {
            icon: "jt",
            name: "交通"
          },
          {
            icon: "ms",
            name: "民生"
          },
          {
            icon: "ty",
            name: "体育"
          },
          {
            icon: "qc",
            name: "汽车"
          },
          {
            icon: "ss",
            name: "时尚"
          },
          {
            icon: "ly",
            name: "旅行"
          },
          {
            icon: "yl",
            name: "娱乐"
          },
        ],
        typeLi: [{
          icon: "tpall",
          name: "全部"
        }],
        mapChartData: [], //地图数据
        hotAllRank: [], //热点事件
        newsType: 4,
        provinceList: [], //地图省份选择列表
        provinceFullList: [], //地图省份选择列表全称
        curFullName: "",
        curMapName: "全国", //
        curProvMapName: "", //省
        curCityMapName: "", //市
        curAreaMapName: "", //县区
        newList: [], //全国新闻列表
        newFir: {}, //全国新闻列表第一条
        curCityName: "", //当前选中省
        curCityFullName: "合肥市", //当前选中省全称
        curCounty: "", //当前选中区县
        province: "安徽省",
        isHasWorld: true, //是否包含国际选项
        cityNewList: [], //各省新闻列表
        cityNewFir: {}, //各省新闻列表第一条
        viewpointList: [],
        nodata: {
          cityNewFir: false,
          hotAllRank: false,
        },
      };
    },
    created() {
      // return;
      if (this.$route.query.index == 0 && this.$route.query.ProvName) {
        this.curMapName = this.$route.query.ProvName;
        this.curProvMapName = this.$route.query.ProvName;
        this.curFullName = this.$route.query.ProvName;
      } else if (this.$route.query.index == 1 && this.$route.query.ProvName) {
        this.curMapName = this.$route.query.ProvName;
        this.curProvMapName = this.$route.query.ProvName;
        this.curFullName = this.$route.query.ProvName;
      }
    },
    mounted() {
      let that = this;

      that.$nextTick(() => {
        that.city();
        that.choseType(1);
        that.hotEventMap();
        that.dataAjax();
        // that.cityNewsAjax();
      });
    },
    methods: {
      changePage(obj, type) {
        var _this = this;

        let newQuery;
        if (type == 0) {
          newQuery = {
            ProvName: this.curProvMapName,
            index: 0,
          };
        } else {
          newQuery = {
            index: 1,
            ProvName: this.curProvMapName,
          };
        }

        _this.$router.push({
          query: newQuery,
          api_secret: that.apiSecret
        });
      },

      getNewQuery(oldQuery, name, val) {
        var obj = {}, // 这里初始化一定是{}而不是null,否则会出错
          flag = false;

        for (key in oldQuery) {
          if (oldQuery.hasOwnProperty(key)) {
            if (key === name) {
              // 这里是修改已有参数
              obj[key] = val;
              flag = true;
            } else {
              obj[key] = oldQuery[key];
            }
          }
        }

        // 这里是新增参数
        if (!flag) {
          obj[name] = val;
        }
        return obj;
      },

      //定义获取城市方法
      city() {
        var that = this;
        let geolocation
        AMap.plugin('AMap.Geolocation', function () {

          geolocation = new AMap.Geolocation({
            timeout: 1000, //若在指定时间内未定位成功，返回超时错误信息“TIMEOUT”
            // GeoLocationFirst: true, //默认为false，设置为true的时候可以调整PC端为优先使用浏览器定位，失败后使用IP定位
            // maximumAge: 0, //定位结果缓存0毫秒，默认：0
            // extensions: 'base' //将得到的经纬度进行逆地理编码后获取地址信息
            trueenableHighAccuracy: true
          });

          geolocation.getCityInfo((status, result) => { //只能获取当前用户所在城市和城市的经纬度
            if (status == "complete") {
              console.log("result", result)
              let city = result.city; //获取城市信息
              let province = result.province; //获取省份信息
              that.province = province;
              that.curCityName = city;
              that.curCityFullName = city;
              that.cityNewsAjax();
            } else {
              that.curCityName = "合肥";
              that.cityNewsAjax();
            }
          })
        })
      },
      choseType(curNum) {
        let that = this,
          url = "";
        that.curNav = curNum;
        if (curNum === 0) {
          url = "news/index/news-type";
        } else if (curNum === 1) {
          url = "hotnews/index/hot-news-type";
        }
        that.typeLi = [{
          icon: "tpall",
          name: "全部"
        }];
        that.$api.get(url, {
          api_secret: that.apiSecret
        }, (r) => {
          that.$parent.returnCode(r, function () {
            that.typeTag = r.data;
            for (let key in r.data) {
              let ele = r.data[key];
              let tmp = {};
              that.typeArr.forEach((e) => {
                if (ele == e.name) {
                  tmp.name = ele;
                  tmp.icon = e.icon;
                  tmp.id = key;
                  that.typeLi.push(tmp);
                }
              });
            }
          });
        });
      },
      hotEventMap(type) {
        let that = this,
          province = "",
          city = "",
          county = "";
        //that.$parent.loadModal(true,'正在获取数据...');
        //that.load.mapChartData = true;
        if (that.curMapName != "全国") {
          province = that.curMapName;
        }
        if (type == 2 || type == 5) {
          province = that.curProvMapName;
          city = that.curCityMapName;
        }
        if (type == 3 || type == 4) {
          province = that.curProvMapName;
          city = that.curCityMapName;
          county = that.curAreaMapName;
        }
        if (county == "" || type == 4) {
          let datas = {
            type: 7,
            news_type: that.newsType,
            province: province,
            city: city,
            api_secret: that.apiSecret
          };
          if (type == 5 && county == "") {
            datas.city = "";
            that.curMapName = province;
          }

          //热点事件地图
          that.$api.get("news/index/hot-list-map", datas, (r) => {
            that.$parent.returnCode(r, function () {
              let data = r.data;
              that.mapChartData = data;
            });
          });
        }
        //热点事件
        let datas1 = {
          type: 7,
          news_type: that.newsType,
          province: province,
          city: city,
          county: county,
          perpage: 10,
          api_secret: that.apiSecret
        };
        that.$api.get("news/index/hot-list", datas1, (r) => {
          that.$parent.returnCode(r, function () {
            that.hotAllRank = r.data.list;
            if (r.data.list.length <= 0) {
              that.nodata.hotAllRank = true;
              return;
            } else {
              that.nodata.hotAllRank = false;
            }
          });
        });
      },
      //地图点击
      fatherMethod(name, id, type) {
        let query = {
          name: name,
          id: id,
          type: type,
        };

        let that = this;
        that.curMapName = name;
        if (type == 2) {
          that.curCityMapName = name;
          that.curFullName = that.curProvMapName + "-" + that.curCityMapName;
          that.hotEventMap(type);
        } else if (type == 3) {
          that.curAreaMapName = name;
          if (that.curCityMapName == "") {
            that.curFullName = that.curProvMapName + "-" + that.curAreaMapName;
          } else {
            that.curFullName =
              that.curProvMapName +
              "-" +
              that.curCityMapName +
              "-" +
              that.curAreaMapName;
          }
          that.hotEventMap(type);
        } else {
          that.curProvMapName = name;
          that.curFullName = that.curProvMapName;
          that.hotEventMap();
        }
        that.$refs.citySelect.fullName = that.curFullName;
        that.$refs.citySelect.clickCityMap(name, type);
        this.changePage(query, 0);
      },
      provinceSelect(name, index, num) {
        let that = this;
        if (num == 1) {
          //that.curMapName = name;
          that.curMapName = that.provinceFullList[index];
          that.curProvMapName = that.curMapName;
          that.hotEventMap();
        } else {
          that.curCityName = name;
          that.curCityFullName = that.provinceFullList[index];
          that.cityNewsAjax();
        }
      },
      dataAjax() {
        let that = this;
        that.$axios.get("static/city.json").then((r) => {
          that.provinceList = r.data.shortProvince;
          that.provinceFullList = r.data.province;
        });
        //that.$parent.loadModal(true,'正在获取数据...');
        //全国新闻
        that.$api.get(
          "news/index/hot-list", {
            type: 1,
            news_type: that.newsType,
            api_secret: that.apiSecret
          },
          (r) => {
            that.$parent.returnCode(r, function () {
              let data = r.data.list;
              if (data.length > 0) {
                data.forEach((ele) => {
                  ele.isLoadStart = false;
                });
                that.newFir = data[0];
                that.newList = data.slice(1, 12);
              }
            });
          }
        );
        //观点
        //that.$api.get('viewpoint/index/homelist',null,r=>{
        // that.$api.get("hotnews/index/tag-list-right", null, (r) => {
        //   that.$parent.returnCode(r, function () {
        //     that.viewpointList = r.data.slice(0, 3);
        //   });
        // });
      },
      citySelect2(name) {
        //路由跳转

        //       0: "安徽省"
        // 1: "合肥市"
        // 2: "合肥"
        // 3: "安徽"
        // 4: "长丰县"
        // 5: "1"
        let province = name[0];
        let fullCity = name[1];
        let city = name[2];
        let county = name[4];
        let type = name[5];
        let that = this;
        that.curAreaMapName =
          county === "全市" || county === "选择区县" ? "" : county;
        that.curCityMapName =
          fullCity === "全省" || fullCity === "选择城市" || city === "全市" ?
          "" :
          fullCity;
        if (province === "全国") {
          that.curMapName = "全国";
          that.curProvMapName = "";
        } else {
          that.curMapName = province;
          that.curProvMapName = that.curMapName;
        }
        if (that.curAreaMapName != "") {
          if (type != 2) {
            that.curMapName = fullCity;
          }
          that.hotEventMap(4);
        } else if (that.curCityMapName != "") {
          that.curMapName = fullCity;
          if (type == 5) {
            that.hotEventMap(type);
          } else {
            that.hotEventMap(2);
          }
        } else {
          that.hotEventMap();
        }
      },
      // 地区筛选
      citySelect1(name) {
        this.curFullName = ""
        let province = name[0];
        let fullCity = name[1];
        let city = name[2];
        let county = name[4];
        let type = name[5];
        let that = this;

        that.curAreaMapName =
          county === "全市" || county === "选择区县" ? "" : county;
        that.curCityMapName =
          fullCity === "全省" || fullCity === "选择城市" || city === "全市" ?
          "" :
          fullCity;
        if (province === "全国") {
          that.curMapName = "全国";
          that.curProvMapName = "";
        } else {
          that.curMapName = province;
          that.curProvMapName = that.curMapName;
        }
        if (that.curAreaMapName != "") {
          if (type != 2) {
            that.curMapName = fullCity;
          }
          that.hotEventMap(4);
        } else if (that.curCityMapName != "") {
          that.curMapName = fullCity;
          if (type == 5) {
            that.hotEventMap(type);
          } else {
            that.hotEventMap(2);
          }
        } else {
          that.hotEventMap();
        }
        this.changePage(name, 1);
      },
      citySelect(name) {
        let province = name[0];
        let fullCity = name[1];
        let city = name[2];
        let county = name[4];
        let that = this;
        that.curCounty = county === "全市" || county === "选择区县" ? "" : county;
        that.curCityFullName =
          fullCity === "全省" || fullCity === "选择城市" ? "" : fullCity;
        that.curCityName =
          city === "全省" || city === "选择城市" || city === "全市" ?
          province :
          city;
        if (province === "全国") {
          that.province = "";
          that.curCityFullName = "";
        } else {
          that.province = province;
        }
        if (province === "国际") {
          that.curCityFullName = "";
          that.curCityName = "国际";
        }
        if (that.curCounty != "") {
          that.curCityName = that.curCounty;
          that.hotEventMap(4);
        } else {}
        that.cityNewsAjax();
        this.changePage(name, 1);
      },
      cityNewsAjax() {
        let that = this;
        let datas = {
          type: 1,
          news_type: that.newsType,
          province: that.province,
          city: that.curCityFullName,
          county: that.curCounty,
          api_secret: that.apiSecret
        };
        that.$api.get("news/index/hot-list", datas, (r) => {
          that.$parent.returnCode(r, function () {
            let data = r.data.list;
            if (data.length > 0) {
              that.nodata.cityNewFir = false;
              data.forEach((ele) => {
                ele.isLoadStart = false;
              });
              that.cityNewFir = data[0];
              that.cityNewList = data.slice(1, 12);
            } else {
              that.nodata.cityNewFir = true;
              that.cityNewFir = data;
              that.cityNewList = data;
            }
          });
        });
      },
      timeFilter(t) {
        var newT = "";
        if (t != null) {
          let tmp = t.split(" ")[0];
          return tmp;
        }
      },
      loadImg(ele, i, item, len) {
        let that = this;
        let img = new Image();
        img.src = ele;
        img.onload = function () {
          if (img.width > 200 && img.width / img.height < 3) {
            item.curImg = ele;
            item.isLoadStart = true;
            return;
          }
          if (i >= len - 1) {
            item.curImg = "";
            item.isLoadStart = true;
            return;
          }
          that.loadImg(item.news_imgs[i + 1], i + 1, item, len);
        };
      },
      imgChose(item) {
        let that = this;
        let len = "";
        if (item.news_imgs == undefined) {
          return;
        } else {
          len = item.news_imgs.length;
        }
        if ((len == 1 && item.news_imgs[0] == "") || len < 1) {
          item.isLoadStart = true;
          item.curImg = "";
          return;
        }
        that.loadImg(item.news_imgs[0], 0, item, len);
      },
    },
  };

</script>



// WEBPACK FOOTER //
// src/page/indexN.vue